import { normalizeHexColor } from "./hex-color";

// sRGB の 1 チャンネル値（0-255）を、相対輝度計算用の線形値へ変換する（WCAG 2.x の定義）。
function channelToLinear(value: number): number {
  const normalized = value / 255;
  return normalized <= 0.03928 ? normalized / 12.92 : ((normalized + 0.055) / 1.055) ** 2.4;
}

// hex 色（#RRGGBB / #RGB）の相対輝度（0=黒 〜 1=白）を返す。
// 入力は呼び出し側で検証済みの hex のみ。不正入力の計算結果は保証しない。
export function relativeLuminanceOfHex(hex: string): number {
  const normalized = normalizeHexColor(hex);
  const r = parseInt(normalized.slice(1, 3), 16);
  const g = parseInt(normalized.slice(3, 5), 16);
  const b = parseInt(normalized.slice(5, 7), 16);
  return 0.2126 * channelToLinear(r) + 0.7152 * channelToLinear(g) + 0.0722 * channelToLinear(b);
}

// 2 つの相対輝度からコントラスト比（1〜21）を返す（WCAG の定義）。
export function contrastRatioOfLuminance(a: number, b: number): number {
  const lighter = Math.max(a, b);
  const darker = Math.min(a, b);
  return (lighter + 0.05) / (darker + 0.05);
}

/** 検証済みの hex 色 2 つのコントラスト比（1〜21）を返す。順序は結果に影響しない。 */
export function contrastRatio(hexA: string, hexB: string): number {
  return contrastRatioOfLuminance(relativeLuminanceOfHex(hexA), relativeLuminanceOfHex(hexB));
}
